import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from "@angular/router";
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {Company} from "../type/company";
import {Category} from "../type/category";
import {Remark} from "../type/remark";

@Component({
    selector: 'app-company-detail',
    templateUrl: './company-detail.component.html'
})
export class CompanyDetailComponent implements OnInit {
    node = 'company';
    companyRemarkNode = 'company-remark';
    companyCategoryNode = 'company-category';

    selectedCompanyId = "";
    selectedCompany: Company = Company;
    companyRemarks: [Remark] = [Remark];
    companyCategories: [Category] = [Category];
    remark: Remark = Remark;

    queryString = "";

    constructor(
        private dataService: DataService,
        private apiService: ApiService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.dataService.refresh();
        this.route.params
            .subscribe(
                (params:Params) => {
                    this.selectedCompanyId = params['id'];
                    this.apiService.getUsingId(this.node, +params['id'])
                        .subscribe((response) => {
                            this.dataService.updateActiveRequestNo(-1);
                            if (response.json().error == true) {
                            } else {
                                this.selectedCompany = response.json().data[0];
                            }
                        });
                    this.getCompanyCategories();

                    this.getCompanyRemarks();

                }
            );
    }

    getCompanyCategories() {
        this.apiService.getAll(this.companyCategoryNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                } else {
                    this.companyCategories = response.json().data;
                }
            });
    }

    getCompanyRemarks() {
        this.queryString = 'company_id=' + this.selectedCompanyId +'&orderby=created_at&order=desc';
        this.apiService.getUsingQuery(this.companyRemarkNode , this.queryString)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.companyRemarks = [Remark];
                } else {
                    this.companyRemarks = response.json().data;
                }
            })
    }

    // onFormSubmit(companyId) {
    //     this.remark.company_id = companyId;
    //     // this.companyRemarkService.postNewRemark(this.remark)
    //     //     .subscribe((response) => {
    //     //             if (response.json().error == true) {
    //     //             } else {
    //     //                 this.companyRemarkService.getCompanyRemarks(companyId)
    //     //                     .subscribe((response) => {
    //     //                         this.companyRemarks = response.json().data;
    //     //                     })
    //     //             }
    //     //         },
    //     //         (error) => alert('Error: Unable to submit form')
    //     //     );
    // }

    onUpdateRemark(remarkId, newRemark, remarkStyle) {
        this.remark.company_remark = newRemark;
        this.remark.company_remark_id = remarkId;
        this.remark.remark_style = remarkStyle;
        console.log(this.remark);
        this.apiService.update(this.companyRemarkNode, [this.remark.company_remark_id], this.remark)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                    } else {
                        this.getCompanyRemarks();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    onDeleteRemark(companyRemarkId) {
        if (confirm('Are you absolutely sure you want to delete?')) {
            this.apiService.delete(this.companyRemarkNode, [companyRemarkId])
                .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.getCompanyRemarks();
                        alert('Unable to delete Company Remark');
                    } else {
                        this.getCompanyRemarks();
                        alert('Company Remark Deleted Successfully');
                    }
                });
        }
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/company-detail/company-detail.component.ts